import React from "react";
// ⚠️ Update this import path to wherever your subsection lives:
//myapp\src\iconosv0\src\screens\ElementHomePage\sections\FootlerSubsection\FootlerSubsection.jsx
import FootlerSubsection from "../../iconosv0/src/screens/ElementHomePage/sections/FootlerSubsection/FootlerSubsection";

const FootlerV2 = () => {
  return (
    <>
      {/* Page-level glow sits OUTSIDE the footer */}
      <span className="page-bottom-glow" aria-hidden="true" />

      <footer className="site-footer" aria-label="Footer">
        <div className="container">
          <FootlerSubsection />
        </div>
      </footer>
    </>
  );
};

export default FootlerV2;
